import React from 'react'
import { Table as ZoneTable } from 'components/table/zones/Table'

const Zones = () => {
    return (
        <>
            <ZoneTable />
        </>
    )
}

export { Zones }